import axios from 'axios';
import {
  generateXB3TraceID,
  getChannelID,
  getHost,
  isSsr,
  getTmxId,
} from '../utils/general';
import { getAuthorizationToken } from '../utils/user';

const REQUEST_TIMEOUT = 20000;

const baseurl = getHost();
const channelId = getChannelID();

const TMXProfileID = isSsr ? '' : getTmxId();

const baseConfig = {
  baseURL: baseurl,
  headers: {
    TMXProfileID,
  },
  timeout: REQUEST_TIMEOUT,
};

const b2cConfig = {
  baseURL: baseurl,
  headers: {
    channelId,
    TMXProfileID,
    Authorization: getAuthorizationToken(),
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  timeout: REQUEST_TIMEOUT,
};

const b2bConfig = {
  baseURL: baseurl,
  headers: {
    channelId,
    TMXProfileID,
    'X-B3-TraceId': generateXB3TraceID(),
  },
  timeout: REQUEST_TIMEOUT,
};

const apiBase = axios.create(baseConfig);

const apiB2C = axios.create(b2cConfig);

const apiB2B = axios.create(b2bConfig);

const getHeadersObj = () => {
  return {
    Accept: 'application/json',
    'Content-type': 'application/json',
    channelId,
    Authorization: getAuthorizationToken(),
    TMXProfileID
  };
};

export const postCall = (url, data) => {
  return axios.post(url, data, {
    headers: getHeadersObj(),
  });
};

export const getCall = (url) => {
  return axios.get(url, {
    method: 'GET',
    headers: getHeadersObj(),
  });
};

export { apiBase, apiB2C, apiB2B };
